export default __webpack_public_path__ + "static/media/photo01.a7846d5c.jpg";